import * as actionTypes from "../constants/actionTypes";
import { OFFER_TYPES } from "../constants/offerTypes";

function getFilterFromInitialFilter(clientConfig, offerType) {
  switch (offerType) {
    case OFFER_TYPES.phoneOffer:
      return clientConfig.widgetOptions.phoneOffer.initialFilter;
    case OFFER_TYPES.proposition:
      return clientConfig.widgetOptions.proposition.initialFilter;
    case OFFER_TYPES.simOnly:
      return clientConfig.widgetOptions.simOnly.initialFilter;
    default:
      return {};
  }
}

const resetFilter = (offerType, clientConfig) => {
  const filter = getFilterFromInitialFilter(clientConfig, offerType);

  return {
    type: actionTypes.RESET_FILTER,
    offerType,
    filter
  };
};

const resetFilters = clientConfig => {
  const phoneOfferFilter = getFilterFromInitialFilter(
    clientConfig,
    "phoneOffer"
  );
  const propositionFilter = getFilterFromInitialFilter(
    clientConfig,
    "proposition"
  );
  const simOnlyFilter = getFilterFromInitialFilter(clientConfig, "simOnly");
  const filter = {
    phoneOffer: phoneOfferFilter,
    proposition: propositionFilter,
    simOnly: simOnlyFilter
  };

  return {
    type: actionTypes.RESET_FILTERS,
    filter
  };
};

const resetFilterWithoutPhone = (offerType, clientConfig) => {
  let filter = getFilterFromInitialFilter(clientConfig, offerType);
  filter = { ...filter };
  delete filter.phoneId;

  return {
    type: actionTypes.UPDATE_FILTER,
    offerType,
    filter
  };
};

const updateFilter = (offerType, filter) => {
  return {
    type: actionTypes.UPDATE_FILTER,
    offerType,
    filter
  };
};

export { resetFilter, resetFilters, resetFilterWithoutPhone, updateFilter };
